import { useRef, useState } from 'preact/hooks';
import css from './PullToRefresh.module.css';

const THRESHOLD = 70; // px — порог срабатывания
const MAX_PULL = 110; // px — макс. визуальный сдвиг

/**
 * Обёртка с pull-to-refresh (нативный жест «потяни вниз — обнови»).
 * Срабатывает только когда страница проскроллена в самый верх.
 * onRefresh может вернуть Promise — индикатор крутится до его резолва.
 */
export function PullToRefresh({ onRefresh, children }) {
  const [pull, setPull] = useState(0);
  const [refreshing, setRefreshing] = useState(false);
  const startY = useRef(0);
  const active = useRef(false);

  function onTouchStart(e) {
    if (refreshing) return;
    // Тянуть можно только от самого верха страницы.
    if (window.scrollY > 0) {
      active.current = false;
      return;
    }
    startY.current = e.touches[0].clientY;
    active.current = true;
  }

  function onTouchMove(e) {
    if (!active.current || refreshing) return;
    const dy = e.touches[0].clientY - startY.current;
    if (dy <= 0) {
      setPull(0);
      return;
    }
    // Резиновое сопротивление.
    const eased = Math.min(MAX_PULL, dy * 0.5);
    setPull(eased);
  }

  async function onTouchEnd() {
    if (!active.current) return;
    active.current = false;
    if (pull >= THRESHOLD && !refreshing) {
      setRefreshing(true);
      setPull(THRESHOLD);
      try {
        await onRefresh?.();
      } catch {
        /* ошибку покажет сам раздел */
      } finally {
        setRefreshing(false);
        setPull(0);
      }
    } else {
      setPull(0);
    }
  }

  const ready = pull >= THRESHOLD;

  return (
    <div
      class={css.wrap}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
      onTouchCancel={onTouchEnd}
    >
      <div
        class={css.indicator}
        style={{ height: `${pull}px`, opacity: pull > 8 ? 1 : 0 }}
        aria-hidden="true"
      >
        <i
          class={`fa-solid fa-arrow-rotate-right ${refreshing ? css.spin : ''}`}
          style={{ transform: refreshing ? 'none' : `rotate(${pull * 2.4}deg)`, color: ready ? 'var(--color-accent-dark)' : '#bbb' }}
        />
      </div>
      <div
        class={css.content}
        style={{
          transform: pull > 0 ? `translateY(${pull}px)` : 'none',
          transition: active.current ? 'none' : 'transform 0.25s ease',
        }}
      >
        {children}
      </div>
    </div>
  );
}
